<template>
  <!-- 字体设置——左侧目录 -->
  <div class="fontLeft">
    <!-- 操作按钮 -->
    <div class="leftButtons">
      <el-tag type="primary" size="small" @click="addFontOpen"><i class="el-icon-plus"></i> 新建字体样式设置</el-tag>
    </div>
    <!-- 目录树 -->
    <div class="treeArea">
      <el-tree ref="tree" node-key="fontStyleId" :props="defaultProps" :accordion="false" highlight-current :data="fontLeftData"
        @node-click="clickNodeTree">
        <div slot-scope="{ node, data }" style="width: 100%">
          <!-- 正常状态 -->
          <div v-if="currentEditId != data.fontStyleId" class="treeItem">
            <img :src="fontSetLeftTreeIcon(node.data)" alt="图标" class="itemImg">
            <div class="itemName" :title="data.fontStyleName">{{ data.fontStyleName }}</div>
            <el-dropdown v-if="data.fontStyleId" trigger="click" placement="bottom-start">
              <i class="el-icon-more"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="copyFont(data)">复制</el-dropdown-item>
                <el-dropdown-item @click.native="editFont(data)">编辑</el-dropdown-item>
                <el-dropdown-item @click.native="deleteFont(data.fontStyleId)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 编辑状态 -->
          <div v-if="currentEditId == data.fontStyleId" class="treeItem">
            <img :src="fontSetLeftTreeIcon(node.data)" alt="图标" class="itemImg">
            <el-input ref="editNameInput" v-model="currentEditName" size="small" maxlength="50" @focus="getInputFocus($event)"
              @blur="handleEditFont(data)" @keyup.enter.native="toBlur">
            </el-input>
          </div>
        </div>
      </el-tree>
    </div>

    <!-- 新建字体样式设置弹框 -->
    <el-dialog v-dialogDrag :visible.sync="addFontSetOpen" title="新建字体样式设置" width="27%" top="25vh" class="dialogRevitAddSet"
      :close-on-click-modal="false" :close-on-press-escape="false" @close="resetAddDialog">
      <!-- 表单 -->
      <el-form ref="addFontForm" :model="addFontForm" label-position="top" size="small" :rules="addFontRules">
        <el-form-item label="字体样式设置名称" prop="fontStyleName">
          <el-input ref="fontStyleName" v-model.trim="addFontForm.fontStyleName" placeholder="请输入字体设置名称" maxlength="50" show-word-limit clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFontSetOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addFontSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { fontSetLeftTreeIcon } from "@/CommonDP/utils/docPublic";
import revitSetService from "@/CommonDP/service/revitSet-service";

export default {
  components: {},
  data() {
    return {
      defaultProps: {
        label: "fontStyleName"
      },
      fontLeftData: [], //  目录树数据
      currentData: {}, // 当前的文件夹
      currentFontStyleId: "", // 当前字体设置id
      currentEditType: "", // 当前编辑状态的类型
      currentEditId: "", // 当前编辑状态的id
      currentEditName: "", // 当前编辑状态的name

      addFontSetOpen: false, // 新增字体设置弹框
      addFontForm: {
        fontStyleName: ""
      }, // 新增字体表单
      addFontRules: {
        fontStyleName: [{ required: true, message: "请输入字体设置名称", trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  async mounted() {
    await this.getFontLeftData();
  },
  methods: {
    addFontOpen() {
      this.addFontSetOpen = true;
      this.$nextTick(() => {
        this.$refs.fontStyleName.focus();
        this.$refs.addFontForm.resetFields();
      });
    },
    // 获取左侧数据
    async getFontLeftData() {
      const type = 1; // 1公共，2个人
      const res = await revitSetService.getFontLeftData(this.enterpriseId, type);
      this.fontLeftData = res.data;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentFontStyleId);
      });
    },

    // 树前面的图标
    fontSetLeftTreeIcon(data) {
      return fontSetLeftTreeIcon(data);
    },
    // 点击树节点
    clickNodeTree(data, node, resolve) {
      this.currentData = data;
      if (data.fontStyleId && data.fontStyleId.indexOf("copy") == -1) {
        this.currentFontStyleId = data.fontStyleId;
        this.$emit("setCurrentFont", data);
      }
    },

    // 重置新增弹框
    resetAddDialog() {
      this.addFontForm.fontStyleName = "";
      this.$refs.addFontForm.resetFields();
    },
    // 新增字体弹框提交
    addFontSet() {
      this.$refs.addFontForm.validate(async valid => {
        if (valid) {
          const params = {
            enterpriseId: this.enterpriseId,
            fontStyleName: this.addFontForm.fontStyleName,
            type: 1 // 1公共，2个人
          };
          await revitSetService.addFontSetLeft(params);
          await this.getFontLeftData();
          this.$message.success("添加字体样式设置成功");
          this.addFontSetOpen = false;
        }
      });
    },

    // 复制字体设置
    copyFont(data) {
      const set = { ...data };
      set.fontStyleId = set.fontStyleId + "copy";
      let position = 0;
      this.fontLeftData.forEach((item, index) => {
        if (item.fontStyleId == data.fontStyleId) position = index + 1;
      });
      this.fontLeftData.splice(position, 0, set);
      this.currentEditType = "copyFont";
      this.currentEditId = set.fontStyleId;
      this.currentEditName = set.fontStyleName;
      this.$nextTick(() => {
        this.$refs.editNameInput.focus();
      });
    },
    // 编辑字体设置
    editFont(data) {
      this.currentEditType = "editFont";
      this.currentEditId = data.fontStyleId;
      this.currentEditName = data.fontStyleName;
      this.$nextTick(() => {
        this.$refs.editNameInput.focus();
      });
    },
    // 进入可编辑状态，默认全选文字
    getInputFocus(event) {
      event.currentTarget.select();
    },
    // 回车失去焦点
    toBlur() {
      this.$refs.editNameInput.blur();
    },
    // 处理编辑字体结果
    async handleEditFont(data) {
      data.fontStyleName = this.currentEditName;
      this.currentEditId = "";
      this.currentEditName = "";
      if (this.currentEditType == "copyFont") {
        let fontStyleId = data.fontStyleId;
        fontStyleId = fontStyleId.substring(0, fontStyleId.length - 4);
        const params = {
          enterpriseId: this.enterpriseId,
          fontStyleId,
          fontStyleName: data.fontStyleName,
          type: 1 // 1公共，2个人
        };
        try {
          await revitSetService.copyFontSetLeft(params);
          await this.getFontLeftData();
          this.$message.success("复制成功");
        } catch (error) {
          this.getFontLeftData();
        }
      }
      if (this.currentEditType == "editFont") {
        const params = {
          fontStyleId: data.fontStyleId,
          fontStyleName: data.fontStyleName
        };
        try {
          await revitSetService.editFontSetLeft(params);
          await this.getFontLeftData();
          this.$message.success("重命名成功");
        } catch (error) {
          this.getFontLeftData();
        }
      }
    },

    // 删除字体设置
    deleteFont(fontStyleId) {
      this.$confirm("是否确认删除该字体样式设置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await revitSetService.deleteFontSetLeft(fontStyleId);
        await this.getFontLeftData();
        if (this.currentFontStyleId == fontStyleId) {
          this.currentFontStyleId = "";
          this.$emit("setCurrentFont", {});
        }
        this.$message.success("删除成功");
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.fontLeft {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .leftButtons {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    display: flex;
    justify-content: space-between;

    .el-tag {
      width: 100%;
      height: max-content;
      padding: 5px;
      background: #e4ebfc;
      text-align: center;
      font-size: 14px;
      color: #346ffa;
      cursor: pointer;
    }
    .el-tag:hover {
      opacity: 0.8;
    }
  }

  .treeArea {
    width: 100%;
    height: 1px;
    flex: 1 0 1px;
    padding: 0 var(--big-space);
    overflow-y: auto;

    .treeItem {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      padding-right: 25px;

      .itemImg {
        margin-right: 6px;
        -webkit-user-drag: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
      }

      .itemName {
        width: 1px;
        flex-grow: 1;
        margin-right: 10px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
